import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { deleteUser, getAuth } from "firebase/auth";
import { deleteDoc, doc } from "firebase/firestore";
import { db } from "../../utils/firebase/firebase.utils";

function VerifyMailResend({
  show,
  setShow,
  VerifyUser,
  id,
  verifyEmail,
  resendEmail,
  email,
}) {
  const { i18n } = useTranslation();
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    if (show) {
      const savedTimer = localStorage.getItem("resendTimer");
      setTimer(savedTimer ? parseInt(savedTimer) : 60);
    }
  }, [show]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prev) => {
          const updated = prev - 1;
          localStorage.setItem("resendTimer", updated);
          return updated;
        });
      }, 1000);
      return () => clearInterval(countdown);
    }
  }, [timer]);

  const handleCancel = async () => {
    console.log(verifyEmail, "verifyEmail cancel");
    console.log(email, "email cancel");
    // return;
    // Store current state
    localStorage.setItem("signupEmail", email);
    localStorage.setItem("resendTimer", timer);

    setShow(false);
  };

  const handleResend = () => {
    resendEmail();
    setTimer(60);
    localStorage.setItem("resendTimer", 60);
  };

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="lg"
      className="modal fade error-modal p-2 p-md-0 montserrat-font"
      centered
    >
      <Modal.Body>
        <div
          id={id}
          className="d-flex"
          style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
        >
          <div className="flex-col w-100">
            <div className="pt-2">
              <div className="row">
                <div
                  className="text-start"
                  style={{
                    color: "#777777",
                    fontSize: "16px",
                    direction: i18n.language === "ar" ? "rtl" : "ltr",
                  }}
                >
                  <p
                    style={{
                      color: "black",
                      fontWeight: "500",
                    }}
                  >
                    {i18n.language === "ar"
                      ? "يرجى التحقق من بريدك الإلكتروني"
                      : "Please verify your email"}
                  </p>
                  <div className="flex-col w-100">
                    <p
                      className="mb-1"
                      style={{
                        fontSize: "14px",
                        fontWeight: "500",
                        color: "#737373",
                      }}
                    >
                      {i18n.language === "ar"
                        ? `يرجى التحقق من البريد الإلكتروني ${verifyEmail} والنقر على رابط التحقق`
                        : `Please check ${verifyEmail} inbox and click the verification link`}
                    </p>
                    <p
                      className="mt-2"
                      style={{
                        fontSize: "14px",
                        fontWeight: "400",
                        color: "#737373",
                      }}
                    >
                      {timer > 0 ? (
                        i18n.language === "ar" ? (
                          <>إعادة الإرسال بعد: {timer} ثانية</>
                        ) : (
                          <>Resend after: {timer} sec</>
                        )
                      ) : (
                        <span
                          style={{
                            color: "#C6AC96",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                          onClick={handleResend}
                        >
                          {i18n.language === "ar"
                            ? "إعادة إرسال البريد الإلكتروني"
                            : "Resend Email"}
                        </span>
                      )}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col mt-4">
                <motion.button
                  whileHover={{ scale: 1.03, opacity: 0.9 }}
                  transition={{ type: "spring", stiffness: 300 }}
                  style={{
                    outline: "none",
                    width: "100%",
                    backgroundColor: "#C6AC96",
                    color: "white",
                    fontSize: "16px",
                    fontWeight: "500",
                    border: "none",
                    height: "45px",
                    borderRadius: "2px",
                  }}
                  onClick={handleCancel}
                >
                  {i18n.language === "ar" ? "افتح البريد الإلكتروني" : "Cancel"}
                </motion.button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default VerifyMailResend;
